module.exports = __webpack_public_path__ + "img/IMG_7095.d308a0a4.webp";